import { useConnectModal, useOpenModal } from '@rainbow-modules/hooks';
import { StyledDrawer } from './styled';
import CreateEditPhoneNumberForm from './CreateEditPhoneNumberForm';
import { FormOpenMode } from './CreateEditPhoneNumberForm/types';

const CreateEditPhoneNumberDrawer = ({
    modalId,
    phoneTypes = [],
}: {
    modalId: string,
    phoneTypes?: string[],
}) => {
    const connectedAddModifyProps = useConnectModal(
        modalId,
        { size: 'small', slideFrom: 'right' },
    );

    const [, closeDrawer] = useOpenModal(modalId);
    const {
        mode = 'create',
        initialValues = {},
        onSubmit,
        ...drawerProps
    } = connectedAddModifyProps;

    return (
        <StyledDrawer
            {...drawerProps}
            onRequestClose={closeDrawer}
        >
            <CreateEditPhoneNumberForm
                mode={mode as FormOpenMode}
                onRequestClose={closeDrawer}
                initialValues={initialValues}
                onSubmit={onSubmit}
                phoneTypes={phoneTypes}
            />
        </StyledDrawer>
    );
};

export default CreateEditPhoneNumberDrawer;
